import { useEffect, useState } from "react";
import { apiGet, apiPost } from "../api/api";

function renderMedia(url) {
  if (!url) return <span>Sem prova</span>;

  const ext = url.toLowerCase();

  if (
    ext.endsWith(".jpg") ||
    ext.endsWith(".jpeg") ||
    ext.endsWith(".png") ||
    ext.endsWith(".gif")
  ) {
    return (
      <img
        src={url}
        alt="Prova"
        style={{
          width: 160,
          height: 90,
          objectFit: "cover",
          borderRadius: 8,
          border: "1px solid #aaa",
        }}
        onError={(e) => {
          e.target.replaceWith(document.createTextNode("Sem prova"));
        }}
      />
    );
  }

  // fallback: assumir vídeo, se falhar troca para imagem
  return (
    <video
      src={url}
      style={{
        width: 160,
        height: 90,
        objectFit: "cover",
        borderRadius: 8,
        border: "1px solid #aaa",
      }}
      controls
      muted
      onError={(e) => {
        const img = document.createElement("img");
        img.src = url;
        img.alt = "Prova";
        img.style =
          "width:160px;height:90px;object-fit:cover;border-radius:8px;border:1px solid #aaa;";
        e.target.replaceWith(img);
      }}
    />
  );
}

export default function RelatorioProvas() {
  const [marca, setMarca] = useState("");
  const [inicio, setInicio] = useState("");
  const [fim, setFim] = useState("");
  const [registos, setRegistos] = useState([]);

  const [linkPublico, setLinkPublico] = useState("");
  const [gerarLoading, setGerarLoading] = useState(false);

  // ✅ NOVO: opções de restrições para o link público
  const [restricoesAtivas, setRestricoesAtivas] = useState(false);
  const [raioRestricoes, setRaioRestricoes] = useState(150);

  // 🔍 Pesquisa com opção de usar valores passados (útil para ler da URL)
  async function pesquisar(marcaArg, inicioArg, fimArg) {
    const marcaFinal = marcaArg ?? marca;
    const inicioFinal = inicioArg ?? inicio;
    const fimFinal = fimArg ?? fim;

    if (!marcaFinal) return;

    let url = `/relatorios/provas?marca=${encodeURIComponent(marcaFinal)}`;
    if (inicioFinal) url += `&data_inicio=${inicioFinal}`;
    if (fimFinal) url += `&data_fim=${fimFinal}`;

    const data = await apiGet(url);
    setRegistos(data);

    // Atualizar URL para poder partilhar o link interno da app
    const params = new URLSearchParams();
    params.set("marca", marcaFinal);
    if (inicioFinal) params.set("data_inicio", inicioFinal);
    if (fimFinal) params.set("data_fim", fimFinal);

    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.history.replaceState(null, "", newUrl);
  }

  // 🧷 Ao abrir a página, se a URL já tiver parâmetros, usar logo
  useEffect(() => {
    const qs = new URLSearchParams(window.location.search);
    const marcaQ = qs.get("marca") || "";
    const inicioQ = qs.get("data_inicio") || "";
    const fimQ = qs.get("data_fim") || "";

    if (marcaQ) {
      setMarca(marcaQ);
      setInicio(inicioQ);
      setFim(fimQ);
      pesquisar(marcaQ, inicioQ, fimQ);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 🔗 Gerar link público com token
  async function gerarLinkPublico() {
    if (!marca) {
      alert("Indica a marca antes de gerar o link.");
      return;
    }

    try {
      setGerarLoading(true);

      // construir query string
      const params = new URLSearchParams();
      params.set("marca", marca);
      if (inicio) params.set("data_inicio", inicio);
      if (fim) params.set("data_fim", fim);

      // ✅ NOVO: enviar configurações de restrições
      params.set("restricoes_ativas", restricoesAtivas ? "true" : "false");
      params.set("restricoes_raio_m", String(raioRestricoes));

      // chamar backend com query + body vazio
      const data = await apiPost(
        `/relatorios/provas/link-publico?${params.toString()}`,
        {}
      );

      // data.url vem do backend (ex: /api/relatorios/provas/publico/{token})
      const absoluteUrl = data.url.startsWith("http")
        ? data.url
        : `${window.location.origin}${data.url}`;

      setLinkPublico(absoluteUrl);
      alert("Link público gerado com sucesso!");
    } catch (err) {
      console.error(err);
      alert("Erro a gerar link público.");
    } finally {
      setGerarLoading(false);
    }
  }

  async function copiarLink() {
    if (!linkPublico) return;
    try {
      await navigator.clipboard.writeText(linkPublico);
      alert("Link copiado para a área de transferência.");
    } catch {
      alert("Não foi possível copiar automaticamente. Copia manualmente.");
    }
  }

  return (
    <div style={{ padding: 20 }}>
      <h1>📊 Relatório de Provas</h1>

      <div style={{ marginBottom: 10 }}>
        <input
          placeholder="Introduz marca"
          value={marca}
          onChange={(e) => setMarca(e.target.value)}
          style={{ marginRight: 10 }}
        />

        <label style={{ marginRight: 5 }}>Início:</label>
        <input
          type="date"
          value={inicio}
          onChange={(e) => setInicio(e.target.value)}
          style={{ marginRight: 10 }}
        />

        <label style={{ marginRight: 5 }}>Fim:</label>
        <input
          type="date"
          value={fim}
          onChange={(e) => setFim(e.target.value)}
          style={{ marginRight: 10 }}
        />

        <button onClick={() => pesquisar()}>Pesquisar</button>

        <button
          onClick={gerarLinkPublico}
          style={{ marginLeft: 10 }}
          disabled={gerarLoading}
        >
          {gerarLoading ? "A gerar..." : "🔗 Gerar link público"}
        </button>
      </div>

      {/* ✅ NOVO: opções para o alerta de restrições no link público */}
      <div
        style={{
          marginTop: 10,
          padding: 10,
          borderRadius: 6,
          border: "1px solid #ddd",
          background: "#fafafa",
          display: "flex",
          gap: 12,
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <label style={{ display: "flex", gap: 6, alignItems: "center" }}>
          <input
            type="checkbox"
            checked={restricoesAtivas}
            onChange={(e) => setRestricoesAtivas(e.target.checked)}
          />
          Incluir alertas de restrições no relatório público
        </label>

        <label style={{ display: "flex", gap: 6, alignItems: "center" }}>
          Raio (m):
          <input
            type="number"
            min={0}
            value={raioRestricoes}
            onChange={(e) => setRaioRestricoes(Number(e.target.value || 0))}
            style={{ width: 90 }}
            disabled={!restricoesAtivas}
          />
        </label>

        {!restricoesAtivas && (
          <span style={{ fontSize: 12, color: "#666" }}>
            (desativado: o relatório público não mostrará alertas de proximidade)
          </span>
        )}
      </div>

      {linkPublico && (
        <div
          style={{
            marginTop: 10,
            padding: 10,
            borderRadius: 6,
            border: "1px solid #ccc",
            background: "#f9f9f9",
          }}
        >
          <strong>Link público:</strong>
          <div style={{ marginTop: 5, display: "flex", gap: 8 }}>
            <input type="text" value={linkPublico} readOnly style={{ flex: 1 }} />
            <button onClick={copiarLink}>Copiar</button>
          </div>
        </div>
      )}

      <hr />

      {registos.map((r) => (
        <div key={r.id} style={{ marginBottom: 20 }}>
          <h3>
            Face #{r.face_id} — Inventário #{r.inventario_id} — {r.operador}
          </h3>
          <p>
            <strong>Data:</strong> {new Date(r.data).toLocaleString("pt-PT")} <br />
            <strong>Campanha:</strong> {r.campanha}
          </p>

          {renderMedia(r.ficheiro)}
        </div>
      ))}

      {registos.length === 0 && (
        <p style={{ marginTop: 20 }}>Sem registos para estes filtros.</p>
      )}
    </div>
  );
}
